"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = { class: "text-sm py-2" };
const _hoisted_3 = { class: "btn-group flex !justify-start" };
const _hoisted_4 = ["title"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-remove" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = {
    key: 0,
    class: "text-sm py-2 uppercase font-bold pb-3 text-green"
};
const _hoisted_8 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-2" };
const _hoisted_9 = { class: "btn-group flex !justify-end pt-2" };
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["title"];
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-remove" }, null, -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = { class: "relative flex justify-end mt-1" };
const _hoisted_15 = { class: "bg-gray-dark text-white text-xs py-1 px-4 font-bold rounded-b" };
const _hoisted_16 = { class: "overflow-y-scroll max-h-[500px]" };
const _hoisted_17 = { class: "flex items-center justify-center gap-2" };
const _hoisted_18 = { class: "text-center font-bold" };
const _hoisted_19 = { class: "flex items-center justify-center gap-2" };
const _hoisted_20 = { class: "text-center font-bold" };
const _hoisted_21 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_24 = [
    _hoisted_23
];
const _hoisted_25 = ["onClick"];
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const SearchInput_vue_1 = __importDefault(require("../../components/Form/SearchInput/SearchInput.vue"));
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const productListStore_1 = require("../../stores/product/list/productListStore");
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const i18n_1 = require("../../common/i18n");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TyreSearcher',
    props: {
        customerProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const productListStore = (0, productListStore_1.useProductListStore)();
        const defaultAxCategory = (() => {
            return productFilterStore.axCategoriesDropdownInputItems[0].value;
        })();
        const tyresListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "tyre_searcher")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
            },
            {
                key: "productName",
                label: (_b = (0, i18n_1.trans)("name", "Name", "tyre_searcher")) !== null && _b !== void 0 ? _b : "Name",
                value: "productName",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const searchLimit = (0, vue_3.ref)(250);
        const modalIsOpen = (0, vue_3.ref)(false);
        const selectedAxCategory = (0, vue_3.ref)(defaultAxCategory);
        //A kereső érték lehet nameAlias, treadCode (mintázat) vagy manufacturerSku (cikkszám)
        const freeWordSearcherKeyword = (0, vue_3.ref)(null);
        const selectedBrandCode = (0, vue_3.ref)(null);
        const selectedWidth = (0, vue_3.ref)(null);
        const selectedProfile = (0, vue_3.ref)(null);
        const selectedDiameter = (0, vue_3.ref)(null);
        const selectedLoadIndex = (0, vue_3.ref)(null);
        const selectedSpeedIndex = (0, vue_3.ref)(null);
        const selectedProduct = (0, vue_3.ref)(null);
        const freeWordSearcherOptions = (0, vue_3.computed)(() => {
            return freeWordSearcherKeyword.value !== null
                ? []
                : [
                    ...productFilterStore.nameAliasSearchInputOptions,
                    ...productFilterStore.treadCodeSearchInputOptions,
                    ...productFilterStore.manufacturerSkuSearchInputOptions,
                ];
        });
        const productFilterValueFilter = (0, vue_3.computed)(() => {
            let selectedFilters = {};
            if (selectedAxCategory.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    axCategory: String(selectedAxCategory.value),
                };
            }
            if (freeWordSearcherKeyword.value !== null &&
                freeWordSearcherKeyword.value !== "") {
                let belongsToNameAliasSearchInputOptions = productFilterStore.nameAliasSearchInputOptions.find((option) => option.value === freeWordSearcherKeyword.value) !== undefined;
                if (belongsToNameAliasSearchInputOptions !== undefined) {
                    delete selectedFilters.treadCode;
                    delete selectedFilters.manufacturerSku;
                    selectedFilters = {
                        ...selectedFilters,
                        nameAlias: String(freeWordSearcherKeyword.value),
                    };
                }
                let belongsToTreadCodeSearchInputOptions = productFilterStore.treadCodeSearchInputOptions.find((option) => option.value === freeWordSearcherKeyword.value) !== undefined;
                if (belongsToTreadCodeSearchInputOptions) {
                    delete selectedFilters.nameAlias;
                    delete selectedFilters.manufacturerSku;
                    selectedFilters = {
                        ...selectedFilters,
                        treadCode: String(freeWordSearcherKeyword.value),
                    };
                }
                let belongsToManufacturerSkuSearchInputOptions = productFilterStore.manufacturerSkuSearchInputOptions.find((option) => option.value === freeWordSearcherKeyword.value) !== undefined;
                if (belongsToManufacturerSkuSearchInputOptions) {
                    delete selectedFilters.nameAlias;
                    delete selectedFilters.treadCode;
                    selectedFilters = {
                        ...selectedFilters,
                        manufacturerSku: String(freeWordSearcherKeyword.value),
                    };
                }
            }
            if (selectedBrandCode.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    brandCode: String(selectedBrandCode.value),
                };
            }
            if (selectedWidth.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    width: String(selectedWidth.value),
                };
            }
            if (selectedProfile.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    profile: String(selectedProfile.value),
                };
            }
            if (selectedDiameter.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    diameter: String(selectedDiameter.value),
                };
            }
            if (selectedLoadIndex.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    loadIndex: String(selectedLoadIndex.value),
                };
            }
            if (selectedSpeedIndex.value !== null) {
                selectedFilters = {
                    ...selectedFilters,
                    speedIndex: String(selectedSpeedIndex.value),
                };
            }
            return selectedFilters;
        });
        const productFilter = (0, vue_3.computed)(() => {
            return productFilterValueFilter.value;
        });
        (0, vue_3.watch)(productFilterValueFilter, (newValue, oldValue) => {
            if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                return;
            }
            productFilterStore.getProductFilters(router, newValue);
        });
        const openChooseTyreModal = () => {
            modalIsOpen.value = true;
        };
        const getProducts = () => {
            productListStore.getProducts(router, productFilter.value);
        };
        const selectTyre = (product) => {
            var _a;
            selectedProduct.value = product;
            props.customerProductReturnCreateRequest.filterpid =
                (_a = selectedProduct.value) === null || _a === void 0 ? void 0 : _a.id;
            modalIsOpen.value = false;
        };
        const freeWordSearcherKeywordSelected = (selectedInputOption) => {
            freeWordSearcherKeyword.value = selectedInputOption.value;
        };
        const freeWordSearcherKeywordReset = () => {
            freeWordSearcherKeyword.value = null;
        };
        const resetFilters = () => {
            selectedAxCategory.value = defaultAxCategory;
            freeWordSearcherKeyword.value = null;
            selectedBrandCode.value = null;
            selectedWidth.value = null;
            selectedProfile.value = null;
            selectedDiameter.value = null;
            selectedLoadIndex.value = null;
            selectedSpeedIndex.value = null;
            productListStore.list = Array();
        };
        const deselectTyre = () => {
            selectedProduct.value = null;
            props.customerProductReturnCreateRequest.filterpid = null;
        };
        (0, vue_3.onBeforeMount)(() => {
            productFilterStore.getProductFilters(router, productFilterValueFilter.value);
        });
        (0, vue_3.watchEffect)(() => {
            if (props.customerProductReturnCreateRequest !== undefined &&
                props.customerProductReturnCreateRequest.product === null) {
                deselectTyre();
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: (0, vue_2.normalizeClass)(["inline-block btn btn-block btn-rounded btn-primary !rounded", {
                                    'btn-primary': selectedProduct.value !== null,
                                    'btn-danger': selectedProduct.value === null,
                                }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (openChooseTyreModal()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("choose_tyre", "Choose Tyre", "tyre_searcher")), 3),
                        (selectedProduct.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 0,
                                class: "btn btn-rounded btn-neutral !bg-gray",
                                type: "reset",
                                title: (0, vue_2.unref)(i18n_1.trans)('deselect_tyre', 'Deselect tyre', 'tyre_searcher'),
                                onClick: _cache[1] || (_cache[1] = ($event) => (deselectTyre()))
                            }, _hoisted_6, 8, _hoisted_4))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (selectedProduct.value !== null)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, (0, vue_2.toDisplayString)(selectedProduct.value.id) + " - " + (0, vue_2.toDisplayString)(selectedProduct.value.productName), 1))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: (0, vue_2.unref)(i18n_1.trans)('choose_tyre', 'Choose Tyre', 'tyre_searcher'),
                    onClose: _cache[12] || (_cache[12] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => {
                        var _a;
                        return [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createVNode)(SearchInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('free_word_searcher_placeholder', 'Name Aliases (like 2255516) or Tread code or Manufacturer SKU', 'tyre_searcher'),
                                    class: "!w-auto",
                                    options: (0, vue_2.unref)(freeWordSearcherOptions),
                                    "display-value": (_a = freeWordSearcherKeyword.value) !== null && _a !== void 0 ? _a : '',
                                    onSelected: freeWordSearcherKeywordSelected,
                                    onReset: freeWordSearcherKeywordReset
                                }, null, 8, ["placeholder", "options", "display-value"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).axCategoriesDropdownInputItems,
                                    modelValue: selectedAxCategory.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedAxCategory).value = $event)),
                                    "disable-deselect": ""
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).brandDropdownInputItems,
                                    modelValue: selectedBrandCode.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedBrandCode).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('width', 'Width', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).widthDropdownInputItems,
                                    modelValue: selectedWidth.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedWidth).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('profile', 'Profile', 'tyre_searcher'),
                                    class: "h-14",
                                    items: (0, vue_2.unref)(productFilterStore).profileDropdownInputItems,
                                    modelValue: selectedProfile.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedProfile).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).diameterDropdownInputItems,
                                    modelValue: selectedDiameter.value,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedDiameter).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('load_index', 'Load Index', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).loadIndexesDropdownInputItems,
                                    modelValue: selectedLoadIndex.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedLoadIndex).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"]),
                                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('speed_index', 'Speed Index', 'tyre_searcher'),
                                    items: (0, vue_2.unref)(productFilterStore).speedIndexesDropdownInputItems,
                                    modelValue: selectedSpeedIndex.value,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedSpeedIndex).value = $event))
                                }, null, 8, ["placeholder", "items", "modelValue"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "inline-block btn btn-rounded btn-primary",
                                    onClick: _cache[9] || (_cache[9] = ($event) => (getProducts())),
                                    disabled: (0, vue_2.unref)(productFilterStore).itemCount > searchLimit.value
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search", "Search", "tyre_searcher")), 9, _hoisted_10),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-neutral !bg-gray",
                                    type: "reset",
                                    title: (0, vue_2.unref)(i18n_1.trans)('reset_filters', 'Reset filters', 'tyre_searcher'),
                                    onClick: _cache[10] || (_cache[10] = ($event) => (resetFilters()))
                                }, _hoisted_13, 8, _hoisted_11)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                (0, vue_2.createElementVNode)("label", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("hits_label", "{hits} hits", "tyre_searcher", {
                                    hits: (0, vue_2.unref)(productFilterStore).itemCount,
                                })), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                                    fields: tyresListFields.value,
                                    "onUpdate:fields": _cache[11] || (_cache[11] = ($event) => ((tyresListFields).value = $event)),
                                    items: (0, vue_2.unref)(productListStore).list,
                                    striped: "",
                                    condensed: "",
                                    class: "mt-4"
                                }, {
                                    "head-id": (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("id", "ID", "tyre_searcher")), 1)
                                    ]),
                                    "cell-id": (0, vue_2.withCtx)(({ item: product }) => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)(product.id), 1)
                                    ]),
                                    "head-productName": (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("name", "Name", "tyre_searcher")), 1)
                                    ]),
                                    "cell-productName": (0, vue_2.withCtx)(({ item: product }) => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)(product.productName), 1)
                                    ]),
                                    "cell-actions": (0, vue_2.withCtx)(({ item: product }) => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                            (product === selectedProduct.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 0,
                                                    class: "btn btn-rounded btn-primary btn-link",
                                                    onClick: ($event) => (selectTyre(product))
                                                }, _hoisted_24, 8, _hoisted_22))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (product !== selectedProduct.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 1,
                                                    class: "btn btn-rounded btn-primary btn-link",
                                                    onClick: ($event) => (selectTyre(product))
                                                }, [
                                                    (0, vue_2.createElementVNode)("i", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("choose", "Choose", "tyre_searcher")), 1)
                                                ], 8, _hoisted_25))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["fields", "items"])
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
